import { NO_LABEL_IN_THE_CONTENTFUL } from '@/config/constants';
import { TLabels } from '@/features/contentful/types/types';

interface ISettings {
    [key: string]: string | ISettings;
}

export const getLabel = (key: string, labelName: string, componentSettings?: ISettings) => {
    const labels = (componentSettings?.[key] as TLabels) || {};
    return labels[labelName] ?? `${NO_LABEL_IN_THE_CONTENTFUL} - ${key}.${labelName}`;
};
